/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type Locale } from '@/types/i18n';

export const locationsPrefix: Record<Locale, string> = {
  'en-US': 'locations',
  'es-MX': 'ubicaciones',
  'pt-BR': 'nossas-lojas',
};
